import React from "react";
import "./ArticleListItem.css";
import Table from "react-bootstrap/Table";
import Card from "react-bootstrap/Card";
import Spinner from "react-bootstrap/Spinner";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";
import Badge from "react-bootstrap/Badge";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { updateArticlesMetaApi } from "../../api/articles";

class ArticleListItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      highlightLoading: false,
      freeLoading: false,
      availableLoading: false
    };

    this.handleHighlightClicked = this.handleHighlightClicked.bind(this);
    this.handleFreeClicked = this.handleFreeClicked.bind(this);
    this.handleAvaiClicked = this.handleAvaiClicked.bind(this);
  }

  async handleHighlightClicked() {
    const { updateAnArticleMetaAction, isPdf, article, issueID } = this.props;
    const newHighLight = !article.is_highlight;

    const metaData = {
      [article.id]: {
        is_highlight: newHighLight
      }
    };

    this.setState({ highlightLoading: true });

    try {
      await updateArticlesMetaApi(issueID, isPdf, metaData);
      updateAnArticleMetaAction({ id: article.id, is_highlight: newHighLight });
    } catch (e) {
      toast.error(e.toString());
    }

    this.setState({ highlightLoading: false });
  }

  async handleFreeClicked() {
    const { updateAnArticleMetaAction, isPdf, article, issueID } = this.props;
    const newFree = !article.is_free;

    const metaData = {
      [article.id]: {
        is_free: newFree
      }
    };

    this.setState({ freeLoading: true });

    try {
      await updateArticlesMetaApi(issueID, isPdf, metaData);
      updateAnArticleMetaAction({ id: article.id, is_free: newFree });
    } catch (e) {
      toast.error(e.toString());
    }

    this.setState({ freeLoading: false });
  }

  async handleAvaiClicked() {
    const { updateAnArticleMetaAction, isPdf, article, issueID } = this.props;
    const newAvai = !article.is_available;

    const metaData = {
      [article.id]: {
        is_available: newAvai
      }
    };

    this.setState({ availableLoading: true });

    try {
      await updateArticlesMetaApi(issueID, isPdf, metaData);
      updateAnArticleMetaAction({ id: article.id, is_available: newAvai });
    } catch (e) {
      toast.error(e.toString());
    }

    this.setState({ availableLoading: false });
  }

  render() {
    const { idx, article, issueID, isAdmin, isPdf } = this.props;
    const {
      title,
      subtitle,
      author,
      intro,
      first_page,
      last_page,
      main_artwork
    } = article;

    const startPage = first_page;
    const endPage = last_page;

    const coverImg =
      main_artwork.id == null
        ? ""
        : `${process.env.REACT_APP_API_ROOT}artworks/${main_artwork.id}/static`;

    const {
      is_highlight,
      is_available,
      is_free,
      has_translation,
      is_dirty,
      has_section
    } = article;

    const highlightVariant = is_highlight ? "warning" : "outline-warning";
    const freeVariant = is_free ? "success" : "outline-success";
    const avaiVariant = is_available ? "primary" : "outline-primary";

    return (
      <Card
        style={{ backgroundColor: has_section ? DARK : LIGHT }}
        text="black"
        border="dark"
        className="article_list_card"
      >
        <Link
          style={{ textDecoration: "none", color: "white" }}
          to={`./${issueID}/articles/${article.id}`}
        >
          <Card.Header>
            <span style={{ color: "black" }}>{`${idx}. ${title} `}</span>
            <div>
              {isPdf && (
                <Badge
                  className="article_badge"
                  variant="warning"
                >{`${startPage}~${endPage}`}</Badge>
              )}
              {!is_dirty && (
                <Badge className="article_badge" variant="success">
                  Ready
                </Badge>
              )}
              {has_translation && (
                <Badge className="article_badge" variant="info">
                  Translated
                </Badge>
              )}
            </div>
          </Card.Header>
        </Link>
        <Link
          style={{ textDecoration: "none" }}
          to={`./${issueID}/articles/${article.id}`}
        >
          <Table
            style={{ backgroundColor: has_section ? DARK : LIGHT }}
            size="sm"
            className="article_table table-borderless"
          >
            <tbody>
              <tr>
                <td>
                  <Image className="article_img" src={coverImg} />
                </td>
                <td className="article_attr_table">
                  <table>
                    <tbody>
                      <tr>
                        <td>subtitle</td>
                        <td>{subtitle}</td>
                      </tr>
                      <tr>
                        <td>Contributor</td>
                        <td>{author}</td>
                      </tr>
                      <tr>
                        <td>intro</td>
                        <td>{intro}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </Table>
        </Link>
        {isAdmin && (
          <Card.Footer>
            <div className="article_list_item_btm_container">
              <Button
                className="article_list_item_btm_btn"
                variant={highlightVariant}
                disabled={this.state.highlightLoading}
                onClick={this.handleHighlightClicked}
              >
                {this.state.highlightLoading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  "Highlight"
                )}
              </Button>
              <Button
                className="article_list_item_btm_btn"
                variant={freeVariant}
                disabled={this.state.freeLoading}
                onClick={this.handleFreeClicked}
              >
                {this.state.freeLoading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  "Free"
                )}
              </Button>
              <Button
                className="article_list_item_btm_btn"
                variant={avaiVariant}
                disabled={this.state.availableLoading}
                onClick={this.handleAvaiClicked}
              >
                {this.state.availableLoading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  "Available"
                )}
              </Button>
            </div>
          </Card.Footer>
        )}
      </Card>
    );
  }
}

const LIGHT = "#FAFAFA";
const DARK = "#AFAFAF";

export default ArticleListItem;
